import i18next from "@/i18n";
import type { TOptions } from "i18next";

export const NOTIFICATIONS = {
  // SUCCESS
  SUCCESS_COPY_URL: { message: i18next.t("success.copy_url_title") },
  SUCCESS_LOGIN: { message: i18next.t("success.login_title") },
  SUCCESS_RESTOCK: { message: i18next.t("success.restock_title") },
  SUCCESS_NEWSLETTER_SUBSCRIBE: { message: i18next.t("success.newsletter_subscribe_title") },
  SUCCESS_WISHLIST_ADD: { message: i18next.t("success.wishlist_add_title") },
  SUCCESS_WISHLIST_REMOVE: { message: i18next.t("success.wishlist_remove_title") },
  SUCCESS_ADDRESS_REMOVE: { message: i18next.t("success.address_remove_title") },
  SUCCESS_LOGOUT: { message: i18next.t("success.logout_title") },
  SUCCESS_CANCEL_ORDER: { message: i18next.t("success.cancel_order_title") },
  SUCCESS_RETURN: { message: i18next.t("success.return_title") },
  SUCCESS_MODIFY_ACCOUNT_INFO: { message: i18next.t("success.modify_account_info") },
  SUCCESS_TOSS_VALIDATE: { message: i18next.t("success.validate_toss") },

  // WARNING
  WARNING_LOGIN: { message: i18next.t("warning.login_title") },
  WARNING_NO_CUSTOMER: { message: i18next.t("warning.no_customer_title") },
  WARNING_PASSWORD_NOT_MATCH: { message: i18next.t("warning.not_match_password_title") },
  WARNING_PASSWORD_SAME_AS_BEFORE: { message: i18next.t("warning.same_password_title") },
  WARNING_NUMBER_ONLY: { message: i18next.t("warning.number_only_title") },
  WARNING_NO_PHONE: { message: i18next.t("warning.no_phone_title") },
  WARNING_PHONE: { message: i18next.t("warning.phone_title") },
  WARNING_NO_LOGIN: { message: i18next.t("warning.no_login_title") },
  WARNING_END_SESSION: { message: i18next.t("warning.end_session") },
  WARNING_NO_CART: { message: i18next.t("warning.no_cart_title") },
  WARNING_ADD_CART: { message: i18next.t("warning.add_cart_title") },
  WARNING_CART_EXPIRE: { message: i18next.t("warning.cart_expired") },
  WARNING_NO_PRODUCT: { message: i18next.t("warning.remove_product_title") },
  WARNING_OVER_PRODUCT: { message: i18next.t("warning.over_product_title") },
  WARNING_NO_RETURN: { message: i18next.t("warning.no_return_for_gift_title") },
  WARNING_NO_REASON: { message: i18next.t("warning.no_reason_title") },
  WARNING_NO_DETAIL_REASON: { message: i18next.t("warning.no_detail_reason_title") },
  WARNING_NO_RETURN_PRODUCTS: { message: i18next.t("warning.no_return_product") },
  WARNING_NO_IMAGE: { message: i18next.t("warning.no_image_title") },
  WARNING_SOCIAL_ACCOUNT: (social: TOptions) => ({ message: i18next.t("warning.social_account_title", social) }),
  WARNING_SOCIAL_ACCOUNT_TAKEN: (social: TOptions) => ({
    message: i18next.t("warning.social_account_taken_title", social),
  }),
  WARNING_SOCIAL_NO_CUSTOMER: { message: i18next.t("warning.no_customer") },
  WARNING_SAME_ACCOUNT_INFO: { message: i18next.t("warning.same_account_info") },
  WARNING_DRAFT_ORDER_CALCULATE: { message: i18next.t("warning.fail_calculate_order") },
  WARNING_NO_SHIPPING_OPTION: { message: i18next.t("warning.no_shipping_option") },
  WARNING_NO_SHIPPING_ADDRESS: { message: i18next.t("warning.need_shipping_address_first") },
  WARNING_INVALID_SHIPPING_ADDRESS: { message: i18next.t("warning.necessary_invalid_shipping_address") },
  WARNING_EXCEEDED_PURCHASE_LIMIT: { message: i18next.t("warning.exceed_purchase_limit") },
  WARNING_GIFT_ADJUST: { message: i18next.t("warning.adjust_gift") },
  WARNING_GIFT_QUANTITY_EXCEED: { message: i18next.t("warning.gift_quantity_exceed") },
  WARNING_RESTOCK: { message: i18next.t("warning.already_restock") },

  // ERROR
  ERROR_SERVER: { message: i18next.t("error.server_title") },
  ERROR_SEARCH: { message: i18next.t("error.search_title") },
  ERROR_CHECKOUT: { message: i18next.t("error.checkout_title") },
  ERROR_SELECT_OPTION: { message: i18next.t("error.select_option_title") },
  ERROR_ADDRESS_REMOVE: { message: i18next.t("error.address_remove_title") },
  ERROR_DISCOUNT_CODE: { message: i18next.t("error.discount_code_title") },
  ERROR_ALREADY_USED_DISCOUNT_CODE: { message: i18next.t("error.already_used_discount_code_title") },
  ERROR_DISCOUNT_CODE_API_FAILED: { message: i18next.t("error.failed_api_discount_code") },
  ERROR_CANCEL_ORDER: { message: i18next.t("error.cancel_order_title") },
  ERROR_ALREADY_ENABLED: { message: i18next.t("error.already_enabled_title") },
  ERROR_BAD_DOMAIN: { message: i18next.t("error.bad_domain_title") },
  ERROR_BLANK: { message: i18next.t("error.blank_title") },
  ERROR_CONTAINS_HTML_TAGS: { message: i18next.t("error.contains_html_tags_title") },
  ERROR_CONTAINS_URL: { message: i18next.t("error.contains_url_title") },
  ERROR_CUSTOMER_DISABLED: { message: i18next.t("error.customer_disabled_title") },
  ERROR_INVALID: { message: i18next.t("error.invalid_title") },
  ERROR_INVALID_MULTIPASS_REQUEST: { message: i18next.t("error.invalid_multipass_request_title") },
  ERROR_NOT_FOUND: { message: i18next.t("error.not_found_title") },
  ERROR_PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE: { message: i18next.t("error.password_whitespace_title") },
  ERROR_TAKEN: { message: i18next.t("error.taken_title") },
  ERROR_TOKEN_INVALID: { message: i18next.t("error.token_invalid_title") },
  ERROR_TOO_LONG: { message: i18next.t("error.too_long_title") },
  ERROR_TOO_SHORT: { message: i18next.t("error.too_short_title") },
  ERROR_UNIDENTIFIED_CUSTOMER: { message: i18next.t("error.unidentified_customer_title") },
  ERROR_PAYMENT: { message: i18next.t("error.pay_request") },
  ERROR_RETURN: { message: i18next.t("error.failed_return") },
  ERROR_NO_RETURN_PRODUCT: { message: i18next.t("error.failed_no_return_product") },
  ERROR_EXCEED_QTY: { message: i18next.t("error.exceed_qty") },
  ERROR_ALREADY_DELETE_ACCOUNT: { message: i18next.t("error.already_delete_account") },
};
